import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import compatioImg from '../../styles/images/build-it-out.png';
import CompatioAnalytics from '../../api/CompatioAnalytics';

const trackAnchorClick = data => {
  CompatioAnalytics.track(
    CompatioAnalytics.events.xrsAnchorclick,
    {
      baseFinalProductID: data.productSku,
      baseParentProductID: this.props.productId,
      baseFinalProductName: data.productName,
      clickAction: CompatioAnalytics.clicks.xrsGotoWidget,
    },
    'XRS',
    'V2'
  );
};
const BuildItAnchor = props => {
  const data = props;
  return (
    <a id="xrsanchor" href="#xrs-anchor" onClick={() => trackAnchorClick(data)}>
      <div className="xrs-build-anchor">
        <img src={compatioImg} className="compatio-img" alt="compatio" />
        <span>
          <strong>Add On:</strong>
          <FormattedHTMLMessage
            id="BuildAnchor.link_message"
            defaultMessage="see compatible products"
          />
        </span>
        {/* <button
          onClick={() => {
            const el = document.getElementById('xrs-bundle');
            el.click();
          }}
        >
          Add to cart
        </button> */}
      </div>
    </a>
  );
};

export default BuildItAnchor;
